export default {
  // Phrased to read the same for one citation or several ("Open the sources: 3" /
  // "…: 3, 25") — the scope has no plural forms and one aria-label does not warrant the
  // first. It names the action because the visible content is only a number.
  label: {
    id: 'rm_metal_source_marker_label',
    defaultMessage: 'Open the sources: {numbers}',
  },
} as const
